function share ({
  title = 'TGO',
  imgUrl = 'https://static001.geekbang.org/resource/image/2b/ba/2b4f20656076991cfe54084dee13c2ba.jpg',
  desc = '欢迎加入TGO'
}) {
  if (!window.wx) return
  window.wx.ready(function () {
    window.wx.onMenuShareTimeline({
      title,
      imgUrl,
      link: window.location.href,
      success: function () {},
      cancel: function () {}
    })
    window.wx.onMenuShareAppMessage({
      title,
      desc,
      imgUrl,
      link: window.location.href,
      type: 'link',
      dataUrl: '',
      success: () => {},
      cancel: () => {}
    })
  })
}

export default (config) => {
  if (!config && typeof config !== 'object') config = {}
  share(config)
}
